




import React, { useState } from 'react';
import { Check, X, FileText, User, Bell } from 'lucide-react';
import '../../../../assets/css/student/dashboard/StudentNotification.css';
import StudentLayout from '../../../../layouts/student/StudentLayout';

const NotificationCard = ({
  icon: Icon,
  title,
  description,
  time,
  status,
  actionText,
  iconBg,
  statusColor
}) => (
  <div className="sns-notification-card">
    <div className="sns-notification-content">
      <div className={`sns-notification-icon ${iconBg}`}>
        <Icon className="sns-icon" />
      </div>

      <div className="sns-notification-details">
        <div className="sns-notification-header">
          <h3 className="sns-notification-title">{title}</h3>

          <div className="sns-notification-meta">
            <span className="sns-notification-time">{time}</span>
            {status && (
              <span className={`sns-notification-status ${statusColor}`}>
                {status}
              </span>
            )}
          </div>
        </div>

        <p className="sns-notification-description">{description}</p>
        <button className="sns-notification-action">{actionText}</button>
      </div>
    </div>
  </div>
);

const StudentNotification = () => {
  const [filter, setFilter] = useState('all');
  const [notificationsList, setNotificationsList] = useState([
    {
      icon: FileText,
      title: 'Donation Request Submitted',
      description: 'Your request for scholarship has been submitted.',
      time: '5m ago',
      status: 'Pending',
      statusColor: 'status-pending',
      iconBg: 'icon-blue',
      actionText: 'View Details',
      type: 'unread'
    },
    {
      icon: Check,
      title: 'Donation Request Approved',
      description: 'Your textbook support request has been approved!',
      time: '1h ago',
      status: 'Approved',
      statusColor: 'status-approved',
      iconBg: 'icon-green',
      actionText: 'View Details',
      type: 'read'
    },
    {
      icon: X,
      title: 'Donation Request Rejected',
      description:
        'Your stationery request was rejected. Reason: Insufficient documentation.',
      time: 'Yesterday',
      status: 'Rejected',
      statusColor: 'status-rejected',
      iconBg: 'icon-red',
      actionText: 'View Reason',
      type: 'read'
    },
    {
      icon: User,
      title: 'KYC Verified',
      description: 'Your identity verification has been completed.',
      time: '2 days ago',
      status: 'Verified',
      statusColor: 'status-verified',
      iconBg: 'icon-blue',
      actionText: 'Complete KYC',
      type: 'read'
    },
    {
      icon: Bell,
      title: 'Upload Latest Fee Slip',
      description: 'Please upload your updated fee slip for verification.',
      time: '3 days ago',
      status: null,
      iconBg: 'icon-orange',
      actionText: 'Upload Now',
      type: 'unread'
    }
  ]);

  const handleMarkAllAsRead = () => {
    const updatedNotifications = notificationsList.map(notif => ({
      ...notif,
      type: 'read'
    }));
    setNotificationsList(updatedNotifications);
  };

  const filteredNotifications = notificationsList.filter(notif =>
    filter === 'all' ? true : notif.type === filter
  );

  return (
    <StudentLayout>
    <div className="sns-notification-page">
      <div className="sns-notification-container">

        {/* Header */}
        <div className="sns-page-header">
          <h1 className="sns-page-title">Notifications</h1>
          <p className="sns-page-subtitle">
            Stay updated about your requests & support status.
          </p>
        </div>

        {/* Filters and Mark All as Read */}
        <div className="sns-filter-container">
          <div className="sns-filter-buttons">
            <button
              className={`sns-filter-btn ${filter === 'all' ? 'sns-filter-active' : ''}`}
              onClick={() => setFilter('all')}
            >
              All
            </button>
            <button
              className={`sns-filter-btn ${filter === 'read' ? 'sns-filter-active' : ''}`}
              onClick={() => setFilter('read')}
            >
              Read
            </button>
            <button
              className={`sns-filter-btn ${filter === 'unread' ? 'sns-filter-active' : ''}`}
              onClick={() => setFilter('unread')}
            >
              Unread
            </button>
          </div>

          <button className="sns-mark-read-btn" onClick={handleMarkAllAsRead}>
            <Check className="sns-btn-icon" />
            Mark All as Read
          </button>
        </div>

        {/* Notifications */}
        <div className="sns-notifications-list">
          {filteredNotifications.map((item, index) => (
            <NotificationCard key={index} {...item} />
          ))}
        </div>

      </div>
    </div>
  </StudentLayout>
  );
};

export default StudentNotification;
